import { render, staticRenderFns } from "./statAppointTiqianTianshu.vue?vue&type=template&id=88cf1b7e"
import script from "./statAppointTiqianTianshu.vue?vue&type=script&lang=js"
export * from "./statAppointTiqianTianshu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports